import { Injectable } from '@angular/core';
import { first, BehaviorSubject } from 'rxjs';
import { SettingsApiService } from '@app/services/settings-api.service';
import { MapSettings } from '@app/modules/location/models/settings.model';
@Injectable({
  providedIn: 'root'
})
export class ZoneCheckboxService {
  constructor(private settingsService: SettingsApiService) {}

  isLayersMenuLoaded$ = new BehaviorSubject(false);

  saveZoneCheckboxStatusToSettingsOnClick(zoneCheckbox: HTMLInputElement) {
    zoneCheckbox?.addEventListener('click', e => {
      if ((e.target as HTMLInputElement).checked) {
        this.settingsService.saveSetting(MapSettings.MAP_ZONES, 'true').pipe(first()).subscribe();
      } else {
        this.settingsService.saveSetting(MapSettings.MAP_ZONES, 'false').pipe(first()).subscribe();
      }

      e.stopImmediatePropagation();
    });
  }

  getZoneCheckboxElement() {
    return document.querySelector('input.cypress-show-zones-toggle') as HTMLInputElement;
  }

  setZoneCheckboxStatus(shouldBeChecked: boolean, zoneCheckbox: HTMLInputElement) {
    if (zoneCheckbox === null) {
      return;
    }
    zoneCheckbox.checked = shouldBeChecked;
  }
}
